import { useAuth } from '@/hooks/useAuth';
import { useEffect, useState } from 'react';
import { fetchMyProfile } from '@/services/api';

export function DashboardPage() {
  const { profile, loading } = useAuth();
  const [kycDone, setKycDone] = useState(profile?.status === 'AKTIV');

  if (loading) return <div className="max-w-3xl mx-auto py-12"><p className="text-text-secondary">Laden...</p></div>;

  if (profile?.status === 'PENDING_KYC') {
    return (
      <div className="max-w-3xl mx-auto py-12">
        <h1 className="text-2xl font-serif mb-6">Dashboard</h1>
        <div className="p-4 border border-warning/20 bg-warning/5 rounded-sm">
          <h2 className="text-lg font-serif mb-2">KYC-Upload erforderlich</h2>
          <p className="text-text-secondary text-sm">
            Bitte laden Sie einen Handelsregisterauszugs und ggf. eine Ausweiskopie hoch,
            um Ihr Konto freischalten zu lassen.
          </p>
          <a href="/profil/dokumente" className="btn-primary mt-4 inline-block">Dokumente hochladen</a>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Dashboard</h1>

      {/* Freigegebene Auktionen */}
      <section className="mb-8">
        <h2 className="text-lg font-serif mb-3">Freigegebene Auktionen</h2>
        <p className="text-text-secondary text-sm">Keine Auktionen verfugbar.</p>
      </section>

      {/* Eigene Gebote */}
      <section className="mb-8">
        <h2 className="text-lg font-serif mb-3">Eigene Gebote</h2>
        <p className="text-text-secondary text-sm">Noch keine Gebote abgegeben.</p>
      </section>

      {/* Eigene Anfragen */}
      <section>
        <h2 className="text-lg font-serif mb-3">Eigene Anfragen</h2>
        <p className="text-text-secondary text-sm">Keine Anfragen gestellt.</p>
      </section>
    </div>
  );
}
